import Vue from 'vue';
import VueRouter from 'vue-router';
import Dashboard from '@/views/Dashboard';
import AuthLogin from '@/views/Auth/Login';
import AuthForgotPassword from '@/views/Auth/ForgotPassword';
import AuthResetPassword from '@/views/Auth/ResetPassword';
import store from "@/store";

Vue.use(VueRouter);
const routes = [
    {
        path: '/auth/login',
        name: 'auth.login',
        component: AuthLogin,
        meta: {
            middleware: "guest",
            breadcrumb: 'Login',
        },
    },{
        path: '/auth/forgot-password',
        name: 'auth.forgot-password',
        component: AuthForgotPassword,
        meta: {
            middleware: "guest",
            breadcrumb: 'Forgot Password',
        },
    },{
        path: '/auth/reset-password/:token',
        name: 'auth.reset-password',
        component: AuthResetPassword,
        meta: {
            middleware: "guest",
            breadcrumb: 'Reset Password',
        },
    },{
        path: '/dashboard',
        name: 'dashboard',
        component: Dashboard,
        meta: {
            middleware: "auth",
            breadcrumb: 'Dashboard',
        },
        redirect: {
            name: 'dashboard.home'
        },
        children: [
            {
                path: '/dashboard/home',
                name: 'dashboard.home',
                component: () => import('@/views/Home'),
                meta: {
                    middleware: "auth",
                    breadcrumb: 'Home',
                },
            },{
                path: '/dashboard/faqs',
                name: 'dashboard.faqs',
                component: () => import('@/views/Dashboard/Faqs/Index'),
                meta: {
                    middleware: "auth",
                    breadcrumb: 'FAQs',
                },
            },{
                path: '/dashboard/postcodes',
                name: 'dashboard.postcodes',
                component: () => import('@/views/Dashboard/Postcodes/Index'),
                meta: {
                    middleware: "auth",
                    breadcrumb: 'Postcodes',
                },
            },{
                path: '/dashboard/deliveryregions',
                name: 'dashboard.deliveryregions',
                component: () => import('@/views/Dashboard/DeliveryRegions/Index'),
                meta: {
                    middleware: "auth",
                    breadcrumb: 'Delivery Regions',
                },
            },{
                path: '/dashboard/deliverysizes',
                name: 'dashboard.deliverysizes',
                component: () => import('@/views/Dashboard/DeliverySizes/Index'),
                meta: {
                    middleware: "auth",
                    breadcrumb: 'Delivery Sizes',
                },
            },{
                path: '/dashboard/deliverycharges',
                name: 'dashboard.deliverycharges',
                component: () => import('@/views/Dashboard/DeliveryCharges/Index'),
                meta: {
                    middleware: "auth",
                    breadcrumb: 'Delivery Charges',
                },
            },{
                path: '/dashboard/hotspots',
                name: 'dashboard.hotspots.index',
                component: () => import('@/views/Dashboard/Hotspots/Index'),
                meta: {
                    middleware: "auth",
                    breadcrumb: 'Hotspots',
                },
            },{
                path: '/dashboard/products',
                name: 'dashboard.products',
                component: () => import('@/views/Dashboard/Products/Index.vue'),
                meta: {
                    middleware: "auth",
                    breadcrumb: 'Products',
                },
            },{
                path: '/dashboard/deliverytypes',
                name: 'dashboard.deliverytypes',
                component: () => import('@/views/Dashboard/DeliveryTypes/Index.vue'),
                meta: {
                    middleware: "auth",
                    breadcrumb: 'Delivery Ty[es',
                },
            }
        ],
    },{
        path: '/',
        redirect: {
            name: 'dashboard.home'
        }
    },{
        path: '/app',
        redirect: {
            name: 'dashboard.home'
        }
    }
];

let router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
});

router.beforeEach((to, from, next) => {
    let siteName = process.env.MIX_APP_NAME ?? 'QFConnector';
    document.title = `${to.meta.breadcrumb} – ${siteName}`
    if(to.meta.middleware === "guest") {
        if(store.state.auth.authenticated) {
            next({name: "dashboard.home" });
        }
        next();
    } else {
        if(store.state.auth.authenticated) {
            next();
        } else {
            next({name: "auth.login" });
        }
    }
})

export default router;
